import React, { Component } from "react";
import { Typography, IconButton, Dialog, DialogContent } from "@material-ui/core";
import { Close } from "@material-ui/icons";

export default class ExplicacionCompromisoDeudaComponent extends Component {
  close = () => {
    if (this.props.onClose) {
      this.props.onClose();
    }
  };
  render() {
    return (
      <Dialog open={this.props.open}>
        <DialogContent>
          <div className="cerrarBtnModal">
            <IconButton onClick={this.close}>
              <Close></Close>
            </IconButton>
          </div>
          <Typography className="tituloModalCarnet">Monto máximo Deuda</Typography>
          <Typography>
            Debes indicar el monto máximo del cupo de tu tarjeta o línea de crédito el cual deseas utilizar antes de realizar la portabilidad de tu producto. Con este compromiso, nos das las
            facultades para que pidamos a tu banco actual que bloqueen tu Tarjeta de crédito o Línea de crédito con el fin de no aumentar tu deuda. En caso de no cumplimiento del compromiso por parte
            del solicitante, Banco Ripley puede retractarse de la oferta, incluso cuando ésta ya haya sido aceptada por el cliente.
          </Typography>
        </DialogContent>
        <div>
          <div className="franjaColores">
            <div className="rojo" />
            <div className="amarillo" />
            <div className="morado" />
          </div>
        </div>
      </Dialog>
    );
  }
}
